export type TypeGuardOf<T extends { __TYPE: unknown }> = T["__TYPE"];

export function createTypeGuard<T extends string>(
  options: ReadonlyArray<T> | Array<T>,
) {
  function isType(value: string): value is T {
    for (const option of options) {
      if (option === value) {
        return true;
      }
    }

    return false;
  }

  return isType as typeof isType & { __TYPE: T };
}
